import { useModal } from '../contexts';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';

interface Props {
  onRetry?: () => void;
}

function MicrosoftPopupModal({ onRetry }: Props) {
  const { closeModal } = useModal();
  const { t } = useTranslation();

  const handleRetry = () => {
    closeModal();
    onRetry?.();
  };

  return (
    <Modal
      title={t("Popup Blocked")}
      size='sm'
      primaryButtonProps={
        onRetry
          ? { text: t("Try Again"), onClick: handleRetry }
          : { text: t("Close"), onClick: closeModal }
      }
    >
      <p>
        {t("Your browser blocked a popup window. Please allow popups from app.portant.co and try again.")}
      </p>
    </Modal>
  );
}

export default MicrosoftPopupModal;
